import React from 'react';
import PropTypes from 'prop-types';

const Text = props => (
  <div className="span-geozone">
    <span> {props.language.account.geozone.modalCreate.create} </span>
    <span> {props.language.account.geozone.modalEdit.edit} </span>
  </div>
);

export default Text;



// WEBPACK FOOTER //
// ./source/client/components/account_geozone/text.jsx